module.exports = __webpack_public_path__ + "static/media/noBlog.fe8d8475.png";